import { Link } from 'react-router-dom';
import { Gift } from 'lucide-react';
import { ROUTE_NAMES } from '@tsgecart/config';

/** Static promotional link card to the rewards area -- no rewards API call from the homepage itself. */
export function RewardsPromoSection() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-6 sm:px-8 sm:py-8">
      <Link
        to={ROUTE_NAMES.accountRewards}
        className="focus-visible:ring-brand group flex items-center gap-4 rounded-2xl bg-gray-900 px-6 py-6 text-white transition duration-300 hover:-translate-y-1 hover:bg-gray-800 hover:shadow-lg focus-visible:outline-none focus-visible:ring-2 sm:px-8 sm:py-7"
      >
        <span className="bg-brand flex h-12 w-12 shrink-0 items-center justify-center rounded-full transition-transform duration-300 group-hover:scale-110">
          <Gift className="text-brand-foreground h-6 w-6" aria-hidden="true" />
        </span>
        <span>
          <span className="block text-base font-bold tracking-tight sm:text-lg">Spin to win a discount!</span>
          <span className="block text-sm text-gray-300">Visit Rewards to spin the wheel and unlock offers.</span>
        </span>
      </Link>
    </section>
  );
}
